<div class="corner-icon {{productName}}_icon">
    <svg width="12" height="12" class="icon">
        <use [attr.xlink:href]="link"></use>
    </svg>
    </div>
    <div class="chart-canvas_marker" *ngIf="!loading">
        <div class="d-flex align-items-center hand" (click)="onChange(item,i)" [ngClass]="{'text-decoration-line-through' : item.hide }" *ngFor="let item of chartData ; let i = index">
            <div class="marker" [ngStyle]="{'background-color': item.color}" ></div>
            {{item.name}}
        </div>
    </div>
    <div class="d-flex justify-content-end">

        <h3 class="title-text mb-3 me-auto" *ngIf="showTitle ">Analytics</h3>
        <app-date-component-renderer [isGraphDataChange]="true" [currentDateFilter]="currentDateFilter"></app-date-component-renderer>

    </div> 
<div class="chart-canvas custom-scrollv2" *ngIf="!loading">
<div class="chart-wrapper" [ngStyle]="{'width': (width - 120)+'px'}" id="{{id}}"> 
    <app-lines-chart [type]="type"  [width]="width" [height]="height" [id]="id" [data]="chartData" [yAxisLabelType]="yAxisLabelType" [chartLegendName]="chartLegendName" [chartColors]="chartColors" [labels]="labels" [tickInterval]="tickInterval" ></app-lines-chart>  
</div>
</div> 
<div class="loader" *ngIf="loading">
    <img [src]="'assets/images/nineyard-loading.gif'" />
  </div>